// src/components/About/AboutBanner.jsx
import React from 'react';
import headerBg from '../../assets/images/header/1.png';   // background
import shapeIcon from '../../assets/images/header/2.png';   // shape

const AboutBanner = () => {
  return (
    <section
      className="page-header bg--cover"
      style={{ backgroundImage: `url(${headerBg})` }}
    >
      <div className="container">
        {/* ---------- Text & Breadcrumb ---------- */}
        <div
          className="page-header__content"
          DataAos="fade-right"
          DataAosDuration="1000"
        >
          <h2>About Us</h2>

          <nav
            style={{ '--bs-breadcrumb-divider': "'/'" }}
            aria-label="breadcrumb"
          >
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item">
                <a href="/">Home</a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                About
              </li>
            </ol>
          </nav>
        </div>

        {/* ---------- Shape Icon ---------- */}
        <div className="page-header__shape">
          <span className="page-header__shape-item page-header__shape-item--1">
            <img src={shapeIcon} alt="shape-icon" />
          </span>
        </div>
      </div>
    </section>
  );
};

export default AboutBanner;